const DEFAULT_PY_FILE_CONTENT = `for i in range(1, 5):
    print(f'hello {i}')
`;

export const DEFAULT_FILES = [
  {
    name: 'main.py',
    language: 'python',
    code: DEFAULT_PY_FILE_CONTENT,
  },
];
